export const adminCommunity = {
  // Community Genealogy Tree Admin Page
  "admin.community.communityGenealogyTree.title": "Community-Genealogiebaum",
  "admin.community.communityGenealogyTree.subtitle": "Visualisieren und erkunden Sie die vollständige Empfehlungsstruktur",
  "admin.community.communityGenealogyTree.loading": "Lade Genealogiebaum...",
  "admin.community.communityGenealogyTree.error": "Fehler beim Laden des Genealogiebaums",
  "admin.community.communityGenealogyTree.searchLabel": "Nach Benutzername suchen",
  "admin.community.communityGenealogyTree.searchPlaceholder": "Benutzername eingeben...",
  "admin.community.communityGenealogyTree.searchButton": "Baum laden",
  "admin.community.communityGenealogyTree.resetButton": "Ansicht zurücksetzen",
  "admin.community.communityGenealogyTree.userNotFound": "Benutzer nicht gefunden",
  "admin.community.communityGenealogyTree.searchError": "Fehler beim Suchen des Benutzers",
  "admin.community.communityGenealogyTree.invalidUser": "Ungültiger Benutzer angegeben",
  
  // Tree Node Actions
  "admin.community.treeNode.expand": "Erweitern",
  "admin.community.treeNode.collapse": "Einklappen",
  "admin.community.treeNode.directReferrals": "Direkte Empfehlungen",
  "admin.community.treeNode.loading": "Lädt...",
  
  // Error Messages
  "admin.community.errors.accessDenied": "Zugriff verweigert: unzureichende Berechtigungen",
  "admin.community.errors.userNotFound": "Benutzer nicht gefunden",
  "admin.community.errors.networkError": "Seite neu laden",
  "admin.community.errors.unexpectedError": "Ein unerwarteter Fehler ist aufgetreten"
};